@import "../../global/normalize.css";

:host {
  display: inline-block;

  --ic-input-label-text-color: var(--ic-switch-label);
  --ic-input-label-helper-text-color: var(--ic-switch-help-text);
  --ic-input-label-helpertext-padding: var(--ic-space-xs);
}

input {
  overflow: hidden;
  appearance: none;
}

.ic-switch-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
}

.ic-switch-label {
  margin-left: var(--ic-space-xxs);
  margin-bottom: var(--ic-space-xs);
}

.ic-switch-toggle {
  display: flex;
  align-items: center;
  width: calc(var(--ic-space-xl) * 2);
  height: var(--ic-space-xl);
  position: relative;
  border-radius: 100vw;
  background-color: var(--ic-switch-unchecked-bg);
  border: var(--ic-border-width) solid var(--ic-switch-unchecked);
  box-sizing: border-box;
  transition: var(--ic-transition-duration-fast);
  margin-left: var(--ic-space-xxs);
  gap: calc(var(--ic-space-md) + var(--ic-space-xxs));
}

.ic-switch-small .ic-switch-toggle {
  width: var(--ic-space-xxl);
  height: var(--ic-space-lg);
  gap: calc(var(--ic-space-sm) + var(--ic-space-xxxs));
}

.ic-switch-large .ic-switch-toggle {
  width: calc(var(--ic-space-xl) + var(--ic-space-xxl));
  height: calc(var(--ic-space-xl) + var(--ic-space-xs));
  gap: calc(var(--ic-space-lg) + var(--ic-space-xxs));
}

.ic-switch-line-break {
  flex: 1 0 100%;
}

.ic-switch-toggle::before {
  content: "";
  width: calc(var(--ic-space-sm) * 2);
  height: calc(var(--ic-space-sm) * 2);
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: var(--ic-space-xxs);
  transform: translate(0, -50%);
  background-color: var(--ic-switch-unchecked);
  transition: var(--ic-transition-duration-slow);
}

.ic-switch-small .ic-switch-toggle::before {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
}

.ic-switch-large .ic-switch-toggle::before {
  width: var(--ic-space-xl);
  height: var(--ic-space-xl);
}

.ic-switch-icon {
  display: inline-block;
  vertical-align: middle;
  width: var(--ic-space-sm);
  height: var(--ic-space-sm);
}

.ic-switch-small .ic-switch-icon {
  width: var(--ic-space-xs);
  height: var(--ic-space-xs);
}

.ic-switch-large .ic-switch-icon {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
}

.ic-switch-icon-circle {
  stroke: var(--ic-switch-indicator-off);
  stroke-width: var(--ic-space-1px);
}

.ic-switch-icon-line {
  height: var(--ic-space-sm);
  width: var(--ic-space-1px);
  background-color: var(--ic-switch-indicator-on);
  border-radius: 99px;
  margin-left: calc(
    var(--ic-space-md) + var(--ic-space-xxs) - var(--ic-space-1px)
  );
}

.ic-switch-small .ic-switch-icon-line {
  margin-left: calc(var(--ic-space-md) - var(--ic-space-1px));
  height: var(--ic-space-xs);
}

.ic-switch-large .ic-switch-icon-line {
  margin-left: calc(
    var(--ic-space-xs) + var(--ic-space-md) - var(--ic-space-1px)
  );
  height: var(--ic-space-md);
}

.ic-switch-input:checked + .ic-switch-toggle {
  background-color: var(--ic-switch-checked-bg);
  border: none;
}

.ic-switch-input:checked + .ic-switch-toggle::before {
  transform: translate(calc(var(--ic-space-xl) - var(--ic-space-1px)), -50%);
  background-color: var(--ic-switch-checked);
}

.ic-switch-small .ic-switch-input:checked + .ic-switch-toggle::before {
  transform: translate(calc(var(--ic-space-lg) - var(--ic-space-1px)), -50%);
}

.ic-switch-large .ic-switch-input:checked + .ic-switch-toggle::before {
  transform: translate(
    calc(var(--ic-space-xxl) - var(--ic-space-xs) - var(--ic-space-1px)),
    -50%
  );
}

.ic-switch-input:not([disabled]) + .ic-switch-toggle:hover::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-unchecked-bg-hover);
}

.ic-switch-input:not([disabled]) + .ic-switch-toggle:active::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-unchecked-bg-pressed);
}

.ic-switch-input:not([disabled]):checked + .ic-switch-toggle:hover::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-checked-bg-hover);
}

.ic-switch-input:not([disabled]):checked + .ic-switch-toggle:active::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-checked-bg-pressed);
}

.ic-switch-input:focus:not([disabled]) + .ic-switch-toggle,
.ic-switch-input:focus-visible:not([disabled]) + .ic-switch-toggle {
  box-shadow: var(--ic-border-focus);
}

.ic-switch-disabled {
  cursor: default;
}

.ic-switch-disabled .ic-switch-icon-circle {
  stroke: var(--ic-switch-indicator-off-disabled);
}

.ic-switch-disabled .ic-switch-icon-line {
  background-color: var(--ic-switch-indicator-on-disabled);
}

.ic-switch-input:disabled + .ic-switch-toggle {
  background-color: var(--ic-switch-unchecked-bg-disabled);
  border: var(--ic-space-1px) dashed var(--ic-switch-unchecked-outline-disabled);
}

.ic-switch-input:disabled + .ic-switch-toggle::before {
  background-color: var(--ic-switch-unchecked-disabled);
}

.ic-switch-input:disabled:checked + .ic-switch-toggle {
  background-color: var(--ic-switch-checked-bg-disabled);
  border: var(--ic-border-width) dashed
    var(--ic-switch-checked-outline-disabled);
}

.ic-switch-input:disabled:checked + .ic-switch-toggle::before {
  background-color: var(--ic-switch-checked);
}

::slotted([slot="right-adornment"]) {
  margin-left: var(--ic-space-sm);
  fill: var(--ic-switch-icon);
}

@media (forced-colors: active) {
  .ic-switch-toggle::before {
    width: calc(var(--ic-space-sm) * 2 - var(--ic-space-xxxs));
    height: calc(var(--ic-space-sm) * 2 - var(--ic-space-xxxs));
  }

  .ic-switch-small .ic-switch-toggle::before {
    width: calc(var(--ic-space-md) - var(--ic-space-xxxs));
    height: calc(var(--ic-space-md) - var(--ic-space-xxxs));
  }

  .ic-switch-large .ic-switch-toggle::before {
    width: calc(var(--ic-space-xl) - var(--ic-space-xxxs));
    height: calc(var(--ic-space-xl) - var(--ic-space-xxxs));
  }

  .ic-switch-toggle::before,
  .ic-switch-input:checked + .ic-switch-toggle {
    border: var(--ic-border-hc);
  }

  .ic-switch-input:focus + .ic-switch-toggle {
    border-color: highlight;
    outline: var(--ic-space-xxxs) solid highlight;
  }

  .ic-switch-input:checked + .ic-switch-toggle::before {
    transform: translate(calc(var(--ic-space-xl) - var(--ic-space-xxxs)), -50%);
  }

  .ic-switch-small .ic-switch-input:checked + .ic-switch-toggle::before {
    transform: translate(calc(var(--ic-space-lg) - var(--ic-space-xxxs)), -50%);
  }

  .ic-switch-large .ic-switch-input:checked + .ic-switch-toggle::before {
    transform: translate(
      calc(var(--ic-space-xxl) - var(--ic-space-xs) - var(--ic-space-xxxs)),
      -50%
    );
  }

  .ic-switch-input:disabled + .ic-switch-toggle,
  .ic-switch-input:disabled:checked + .ic-switch-toggle,
  .ic-switch-input:disabled + .ic-switch-toggle::before {
    border-color: GrayText;
  }

  .ic-switch-icon-line {
    background-color: buttonborder;
  }

  .ic-switch-disabled .ic-switch-icon-circle {
    stroke: GrayText;
  }

  .ic-switch-disabled .ic-switch-icon-line {
    background-color: GrayText;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ic-switch-toggle,
  .ic-switch-toggle::before {
    transition: none;
  }
}
